import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 18px 24px;

  .ant-select {
    width: 100%;
  }

  .ant-select-selector {
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    border-radius: 8px !important;
    padding: 0 12px !important;
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.65) !important;
    font-weight: 500;
    line-height: 36px !important;
  }

  .ant-select-arrow {
    color: rgba(0, 0, 0, 0.45) !important;
    display: flex;
    align-items: center;
    padding-top: 0.5rem;
  }

  .ant-select-focused .ant-select-selector {
    border-color: rgba(0, 0, 0, 0.35) !important;
    box-shadow: none !important;
  }
`;

export const CorbanChangeTitleSelector = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;
